/**
 * src/tools/readiness/hoSoSanSang.js — dựng hồ sơ từ câu trả lời của công cụ
 * điểm sẵn sàng rồi chấm theo rubric.
 *
 * Tách khỏi ReadinessTool.jsx để công cụ định giá pre-seed dùng lại đúng cách
 * dựng hồ sơ này khi lấy điểm sang. Hai nơi tự dựng riêng thì sớm muộn sẽ lệch
 * nhau ở một trường nào đó.
 */
import { evaluate } from "@shared/engines/readinessScore.js";
import { READINESS_PRESEED } from "@shared/rubrics/readinessPreseed.js";
import { tyToMoney } from "../../lib/format.js";

export const HANG_MUC_VON = ["PRODUCT", "HIRING", "GTM", "OPS", "LEGAL", "BUFFER"];

/** Giá trị mặc định của phần câu hỏi đơn trong công cụ điểm sẵn sàng. */
export const F_MAC_DINH = {
  entityType: "NONE",
  oneLiner: "",
  problem: "",
  productStage: "IDEA",
  scaleLevel: "",
  moatLevel: "",
  somTy: "",
  marketMethod: "BOTTOM_UP",
  channelLevel: "",
  targetTy: "",
  useOfFundsCount: 0,
  ipAssignment: "NONE",
  runwayMonths: "",
};

/** Câu chọn mức: để trống là "chưa điền", khác với mức 0 là "chưa đạt". */
const mucSo = (v) => (v === "" || v == null ? undefined : Number(v));

/**
 * @param {Object} v - { founders, bangChung, f } đúng như state của công cụ
 * @returns kết quả engine readinessScore
 */
export function chamSanSang({ founders = [], bangChung = [], f = {} } = {}) {
  const ff = { ...F_MAC_DINH, ...f };
  return evaluate({
    rubric: READINESS_PRESEED,
    derived:
      ff.runwayMonths === "" ? {} : { runwayMonths: Number(ff.runwayMonths) },
    profile: {
      identity: { entityType: ff.entityType },
      business: {
        oneLiner: ff.oneLiner,
        problem: ff.problem,
        productStage: ff.productStage,
        scaleLevel: mucSo(ff.scaleLevel),
        moatLevel: mucSo(ff.moatLevel),
      },
      team: {
        founders: founders.map((x) => ({
          id: x.key,
          fullTime: x.fullTime,
          domainYears: Number(x.domainYears) || 0,
          vesting: { hasVesting: x.hasVesting },
        })),
      },
      traction: { evidence: bangChung.map((t) => ({ type: t })) },
      market: {
        som: tyToMoney(ff.somTy),
        method: ff.marketMethod,
      },
      gtm: {
        channelLevel: mucSo(ff.channelLevel),
      },
      fundraise: {
        target: tyToMoney(ff.targetTy),
        useOfFunds: HANG_MUC_VON.slice(0, Number(ff.useOfFundsCount) || 0).map(
          (k) => ({ key: k }),
        ),
      },
      legal: { checklist: { ipAssignment: ff.ipAssignment } },
    },
  });
}
